import adjustmentService from '../../../../domain/services/solicitation/faciliter.adjustment.service';
import { entryKeyOf } from './adjustment.catalog.constants';
import {
    APPLY_FALLBACK, REVERT_FALLBACK, REVERT_SUCCESS, REVERT_REASON, applySuccess
} from './adjustment.action.messages';

const toItems = (selection, batchKey) => selection.map((entry) => ({
    catalogItemId: entry.catalogItemId,
    serviceId: entry.serviceId || undefined,
    calculationServiceId: entry.calculationServiceId || undefined,
    idempotencyKey: entryKeyOf(batchKey, entry.entryId)
}));

export const applyPlan = ({ requestId, responsibleId, responsibleName }, selection, submission) => ({
    call: () => adjustmentService.applyAdjustment(requestId, responsibleId, {
        items: toItems(selection, submission.batchKey),
        reason: submission.reason.trim(),
        reasonTypedByUser: Boolean(submission.reasonTypedByUser)
    }),
    fallback: APPLY_FALLBACK,
    success: applySuccess(responsibleName),
    shouldRefresh: true
});

export const revertPlan = ({ requestId }, adjustment) => ({
    call: () => adjustmentService.revertAdjustment(requestId, adjustment.id, {
        reason: REVERT_REASON,
        idempotencyKey: ['revert', adjustment.id].join('-')
    }),
    fallback: REVERT_FALLBACK,
    success: REVERT_SUCCESS,
    shouldRefresh: true
});
